export const PROFILE_PAGE_LABELS = {
  header: {
    saveContactButton: {
      en: 'Save contact',
      de: 'Kontakt speichern',
      es: 'Guardar contacto',
      it: 'Salva contatto',
      fr: 'Enregistrer le contact',
    },
  },
  customBioTextBox: {
    boxLabel: {
      en: 'About me',
      de: 'Über mich',
      es: 'Sobre mí',
      it: 'Su di me',
      fr: 'À propos de moi',
    },
  },
  contactDetailsBox: {
    email1: {
      en: '$DELETE$',
      de: '$DELETE$',
      es: '$DELETE$',
      it: '$DELETE$',
      fr: '$DELETE$',
    },
    email2: {
      en: '$DELETE$',
      de: '$DELETE$',
      es: '$DELETE$',
      it: '$DELETE$',
      fr: '$DELETE$',
    },
    email3: {
      en: '$DELETE$',
      de: '$DELETE$',
      es: '$DELETE$',
      it: '$DELETE$',
      fr: '$DELETE$',
    },
    assistanceEmail: { en: 'Assistance', de: 'Assistenz' },
    assistancePhone: { en: 'Assistance', de: 'Assistenz' },
    saveContactButton: {
      en: 'vcard',
      de: 'vcard',
      es: 'vcard',
      it: 'vcard',
      fr: 'vcard',
    },
    boxLabel: {
      en: 'My Contact Details',
      de: 'Meine Kontaktdaten',
      es: 'Mis detalles de contacto',
      it: 'I miei dettagli di contatto',
      fr: 'Mes coordonnées',
    },
    mobilePhone: {
      en: 'Mobile',
      de: 'Mobil',
      es: 'Móvil',
      it: 'Cellulare',
      fr: 'Mobile',
    },
    homePhone: {
      en: 'Home',
      de: 'Festnetz',
      es: 'Casa',
      it: 'Casa',
      fr: 'Domicile',
    },
    workPhone: {
      en: 'Work',
      de: 'Arbeit',
      es: 'Trabajo',
      it: 'Lavoro',
      fr: 'Travail',
    },
    hotlinePhone: {
      en: 'Hotline',
      de: 'Hotline',
      es: 'Línea directa',
      it: 'Linea diretta',
      fr: 'Hotline',
    },
    assistance: {
      en: 'Assistance',
      de: 'Assistenz',
      es: 'Asistencia',
      it: 'Assistenza',
      fr: 'Assistance',
    },
    fax: { en: 'Fax', de: 'Fax', es: 'Fax', it: 'Fax', fr: 'Fax' },
    workUrl: {
      en: '$DELETE$',
      de: '$DELETE$',
      es: '$DELETE$',
      it: '$DELETE$',
      fr: '$DELETE$',
    },
  },
  linksBox: {
    boxLabel: {
      en: 'My Links',
      de: 'Meine Links',
      es: 'Mis enlaces',
      it: 'I miei collegamenti',
      fr: 'Mes liens',
    },
  },
  filesBox: {
    boxLabel: {
      en: 'My Files',
      de: 'Meine Dateien',
      es: 'Mis archivos',
      it: 'I miei file',
      fr: 'Mes fichiers',
    },
  },
  teamDirectoryBox: {
    boxLabel: {
      en: 'Team Directory',
      de: 'Teamverzeichnis',
      es: 'Directorio del equipo',
      it: 'Elenco del team',
      fr: 'Annuaire de l’équipe',
    },
  },
  leadGen: {
    bottomCardStatic: {
      title: {
        en: 'Leave me your contact',
        de: 'Hinterlasse Deinen Kontakt',
        es: 'Déjame tu contacto',
        it: 'Lasciami il tuo contatto',
        fr: 'Laissez-moi vos coordonnées',
      },
      submitButton: {
        en: 'Submit',
        de: 'Absenden',
        es: 'Enviar',
        it: 'Invia',
        fr: 'Soumettre',
      },
      gdprConsent: {
        en: 'I confirm that I have read the <0>privacy policy</0> and agree to the processing of my personal data by the user or his company for the stated purposes. I can revoke this consent at any time.',
        de: 'Ich bestätige, dass ich die <0>Datenschutzerklärung</0> zur Kenntnis genommen habe und mit der Verarbeitung meiner personenbezogenen Daten durch den Nutzer oder dessen Firma zu den genannten Zwecken einverstanden bin. Ich kann meine Einwilligung jederzeit widerrufen.',
        es: 'Confirmo que he leído la <0>política de privacidad</0> y acepto el procesamiento de mis datos personales por parte del usuario o su empresa para los fines indicados. Puedo revocar este consentimiento en cualquier momento.',
        it: "Confermo di aver letto la <0>politica sulla privacy</0> e accetto il trattamento dei miei dati personali da parte dell'utente o della sua azienda per gli scopi indicati. Posso revocare questo consenso in qualsiasi momento.",
        fr: 'Je confirme avoir lu la <0>politique de confidentialité</0> et accepter le traitement de mes données personnelles par l’utilisateur ou son entreprise aux fins indiquées. Je peux révoquer ce consentement à tout moment.',
      },
    },
    popup: {
      title: {
        en: 'Send me your contact and\nreceive mine by email:',
        de: 'Sende Deine Kontaktdaten und\nerhalte meine per E-Mail:',
        es: 'Envíame tus datos y\nrecibe los míos por email:',
        it: 'Mandami i tuoi contatti e\nricevi i miei via email:',
        fr: 'Envoyez-moi vos coordonnées et\nrecevez les miennes par e-mail :',
      },
      submitButton: {
        en: "Let's connect",
        de: 'Jetzt vernetzen',
        es: 'Conectemos',
        it: 'Connettiamoci',
        fr: 'Connectons-nous',
      },
      gdprConsent: {
        en: 'By submitting I confirm that I have read the <0>privacy policy</0> and that I consent to the processing of my contact details in the contact management of the Lemontaps user, as well as that of their company, if applicable<1> (privacy policy)</1>. You can revoke this consent at any time.',
        de: 'Durch Absenden bestätige ich, dass ich die <0>Datenschutzerklärung</0> zur Kenntnis genommen habe und mit der Verarbeitung meiner Daten im Kontakt-Management des Lemontaps Nutzers und gegebenfalls seiner Firma<1> (Datenschutzerklärung)</1> zu den genannten Zwecken einverstanden bin. Du kannst jederzeit Deine Einwilligung widerrufen.',
        es: 'Al enviar, confirmo que he leído la <0>política de privacidad</0> y consiento el procesamiento de mis datos de contacto en la gestión de contactos del usuario de Lemontaps, así como de su empresa, si corresponde<1> (política de privacidad)</1>. Puede revocar este consentimiento en cualquier momento.',
        it: "Inviando confermo di aver letto la <0>politica sulla privacy</0> e che acconsento al trattamento dei miei dati di contatto nella gestione dei contatti dell'utente Lemontaps, nonché della sua azienda, se applicabile<1> (politica sulla privacy)</1>. Puoi revocare questo consenso in qualsiasi momento.",
        fr: 'En soumettant, je confirme avoir lu la <0>politique de confidentialité</0> et consentir au traitement de mes coordonnées dans la gestion des contacts de l’utilisateur Lemontaps, ainsi que celui de son entreprise, le cas échéant<1> (politique de confidentialité)</1>. Vous pouvez révoquer ce consentement à tout moment.',
      },
    },
  },
  attributeLabels: {
    firstName: {
      en: 'First Name',
      de: 'Vorname',
      es: 'Nombre',
      it: 'Nome',
      fr: 'Prénom',
    },
    lastName: {
      en: 'Last Name',
      de: 'Nachname',
      es: 'Apellido',
      it: 'Cognome',
      fr: 'Nom de famille',
    },
    academicDegree: {
      en: 'Academic Degree (e.g. Ing., B.Sc.)',
      de: 'Akademischer Grad (z.B. Ing., B.Sc.)',
      es: 'Título académico (e.g. Ing., B.Sc.)',
      it: 'Titolo accademico (es. Ing., B.Sc.)',
      fr: 'Diplôme académique (e.g. Ing., B.Sc.)',
    },
    namePrefix: {
      en: 'Name Prefix',
      de: 'Namenspräfix',
      es: 'Prefijo de nombre',
      it: 'Prefisso del nome',
      fr: 'Préfixe de nom',
    },
    salutation: {
      en: 'Salutation',
      de: 'Anrede',
      es: 'Saludo',
      it: 'Saluto',
      fr: 'Salutation',
    },
    birthday: {
      en: 'Birthday',
      de: 'Geburtstag',
      es: 'Cumpleaños',
      it: 'Compleanno',
      fr: 'Anniversaire',
    },
    position: {
      en: 'Position',
      de: 'Position',
      es: 'Posición',
      it: 'Posizione',
      fr: 'Poste',
    },
    role: { en: 'Role', de: 'Rolle', es: 'Rol', it: 'Ruolo', fr: 'Rôle' },
    company: {
      en: 'Company',
      de: 'Unternehmen',
      es: 'Compañía',
      it: 'Azienda',
      fr: 'Entreprise',
    },
    division: {
      en: 'Division',
      de: 'Abteilung',
      es: 'División',
      it: 'Divisione',
      fr: 'Division',
    },
    email: {
      en: 'E-Mail',
      de: 'E-Mail',
      es: 'Correo electrónico',
      it: 'Email',
      fr: 'E-mail',
    },
    workEmail: {
      en: 'Work E-Mail',
      de: 'E-Mail Arbeit',
      es: 'Correo electrónico laboral',
      it: 'Email di lavoro',
      fr: 'E-mail professionnelle',
    },
    workPhone: {
      en: 'Telephone - Work',
      de: 'Telefon - Arbeit',
      es: 'Teléfono - Trabajo',
      it: 'Telefono - Lavoro',
      fr: 'Téléphone - Travail',
    },
    workFax: {
      en: 'Fax',
      de: 'Fax',
      es: 'Fax',
      it: 'Fax',
      fr: 'Fax',
    },
    mobilePhone: {
      en: 'Telephone - Mobile',
      de: 'Telefon - Mobil',
      es: 'Teléfono - Móvil',
      it: 'Telefono - Cellulare',
      fr: 'Téléphone - Mobile',
    },
    addressee: {
      en: 'Addressee',
      de: 'Adressat',
      es: 'Destinatario',
      it: 'Destinatario',
      fr: 'Destinataire',
    },
    addressLine1: {
      en: 'Address Line 1',
      de: 'Adresszeile 1',
      es: 'Dirección Línea 1',
      it: 'Indirizzo Linea 1',
      fr: 'Adresse Ligne 1',
    },
    addressLine2: {
      en: 'Address Line 2',
      de: 'Adresszeile 2',
      es: 'Dirección Línea 2',
      it: 'Indirizzo Linea 2',
      fr: 'Adresse Ligne 2',
    },
    postCode: {
      en: 'Postcode',
      de: 'PLZ',
      es: 'Código postal',
      it: 'Codice postale',
      fr: 'Code postal',
    },
    city: { en: 'City', de: 'Stadt', es: 'Ciudad', it: 'Città', fr: 'Ville' },
    country: { en: 'Country', de: 'Land', es: 'País', it: 'Paese', fr: 'Pays' },
    notes: { en: 'Notes', de: 'Notizen', es: 'Notas', it: 'Note', fr: 'Notes' },
    preferredLang: {
      en: 'Language',
      de: 'Sprache',
      es: 'Idioma',
      it: 'Lingua',
      fr: 'Langue',
    },
    website: {
      en: 'Website',
      de: 'Webseite',
      es: 'Sitio web',
      it: 'Sito web',
      fr: 'Site Web',
    },
    linkedInLink: {
      en: 'LinkedIn-URL',
      de: 'LinkedIn-URL',
      es: 'LinkedIn-URL',
      it: 'LinkedIn-URL',
      fr: 'LinkedIn-URL',
    },
    numberOfEmployees: {
      en: 'Number of employees',
      de: 'Anzahl der Mitarbeiter:innen',
      es: 'Número de empleados',
      it: 'Numero di dipendenti',
      fr: 'Nombre d’employés',
    },
    createdOn: {
      en: 'Created on',
      de: 'Erstellt am',
      es: 'Creado el',
      it: 'Creato il',
      fr: 'Créé le',
    },
  },
  accountAttributeLabels: {
    firstName: {
      en: 'First Name',
      de: 'Vorname',
      es: 'Nombre',
      it: 'Nome',
      fr: 'Prénom',
    },
    lastName: {
      en: 'Last Name',
      de: 'Nachname',
      es: 'Apellido',
      it: 'Cognome',
      fr: 'Nom de famille',
    },
    academicDegree: {
      en: 'Academic Degree',
      de: 'Akademischer Grad',
      es: 'Título académico',
      it: 'Titolo accademico',
      fr: 'Diplôme académique',
    },
    academicDegree2: {
      en: 'Academic Degree 2',
      de: 'Akademischer Grad 2',
      es: 'Título académico 2',
      it: 'Titolo accademico 2',
      fr: 'Diplôme académique 2',
    },
    namePrefix: {
      en: 'Name Prefix',
      de: 'Namenspräfix',
      es: 'Prefijo de nombre',
      it: 'Prefisso del nome',
      fr: 'Préfixe de nom',
    },
    nameSuffix: {
      en: 'Name Suffix',
      de: 'Namenssuffix',
      es: 'Sufijo de nombre',
      it: 'Suffisso del nome',
      fr: 'Suffixe de nom',
    },
    salutation: {
      en: 'Salutation',
      de: 'Anrede',
      es: 'Saludo',
      it: 'Saluto',
      fr: 'Salutation',
    },
    bioText: {
      en: 'Bio (free text)',
      de: 'Bio (Freitext)',
      es: 'Bio (Texto libre)',
      it: 'Bio (Testo libero)',
      fr: 'Bio (Texte libre)',
    },
    birthday: {
      en: 'Birthday',
      de: 'Geburtstag',
      es: 'Cumpleaños',
      it: 'Compleanno',
      fr: 'Anniversaire',
    },
    position: {
      en: 'Position',
      de: 'Position',
      es: 'Posición',
      it: 'Posizione',
      fr: 'Poste',
    },
    role: { en: 'Role', de: 'Rolle', es: 'Rol', it: 'Ruolo', fr: 'Rôle' },
    company: {
      en: 'Company',
      de: 'Unternehmen',
      es: 'Compañía',
      it: 'Azienda',
      fr: 'Entreprise',
    },
    division: {
      en: 'Division',
      de: 'Abteilung',
      es: 'División',
      it: 'Divisione',
      fr: 'Division',
    },
    email: {
      en: 'Email 1',
      de: 'Email 1',
      es: 'Email 1',
      it: 'Email 1',
      fr: 'Email 1',
    },
    workEmail: {
      en: 'Email 2',
      de: 'Email 2',
      es: 'Email 2',
      it: 'Email 2',
      fr: 'Email 2',
    },
    workEmail2: {
      en: 'Email 3',
      de: 'Email 3',
      es: 'Email 3',
      it: 'Email 3',
      fr: 'Email 3',
    },
    workPhone: {
      en: 'Telephone - Work',
      de: 'Telefon - Arbeit',
      es: 'Teléfono - Trabajo',
      it: 'Telefono - Lavoro',
      fr: 'Téléphone - Travail',
    },
    mobilePhone: {
      en: 'Telephone - Mobile',
      de: 'Telefon - Mobil',
      es: 'Teléfono - Móvil',
      it: 'Telefono - Cellulare',
      fr: 'Téléphone - Mobile',
    },
    homePhone: {
      en: 'Telephone - Home',
      de: 'Telefon - Heim',
      es: 'Teléfono - Casa',
      it: 'Telefono - Casa',
      fr: 'Téléphone - Maison',
    },
    hotlinePhone: {
      en: 'Hotline',
      de: 'Hotline',
      es: 'Hotline',
      it: 'Hotline',
      fr: 'Hotline',
    },
    assistantName: {
      en: 'Assistance Name',
      de: 'Name Assistenz',
      es: 'Nombre Assistenz',
      it: 'Nome Assistenz',
      fr: 'Nom Assistenz',
    },
    assistantPhone: {
      en: 'Telephone - Assistance',
      de: 'Telefon Assistenz',
      es: 'Teléfono Assistenz',
      it: 'Telefono Assistenz',
      fr: 'Téléphone Assistenz',
    },
    assistantEmail: {
      en: 'Assistance Email',
      de: 'Email Assistenz',
      es: 'Correo electrónico del asistente',
      it: "Email dell'assistente",
      fr: "E-mail de l'assistant",
    },
    assistantGeneric: {
      en: 'Assistance Misc',
      de: 'Assistenz Sonstiges',
      es: 'Assistenz Misc',
      it: 'Assistenz Misc',
      fr: 'Assistenz Misc',
    },
    workFax: {
      en: 'Fax',
      de: 'Fax',
      es: 'Fax',
      it: 'Fax',
      fr: 'Fax',
    },

    address1_addressee: {
      en: 'Addressee',
      de: 'Adressat',
      es: 'Destinatario',
      it: 'Destinatario',
      fr: 'Destinataire',
    },
    address1_addressLine1: {
      en: 'Address Line 1',
      de: 'Adresszeile 1',
      es: 'Dirección Línea 1',
      it: 'Indirizzo Linea 1',
      fr: 'Adresse Ligne 1',
    },
    address1_addressLine2: {
      en: 'Address Line 2',
      de: 'Adresszeile 2',
      es: 'Dirección Línea 2',
      it: 'Indirizzo Linea 2',
      fr: 'Adresse Ligne 2',
    },
    address1_postCode: {
      en: 'Postcode',
      de: 'PLZ',
      es: 'Código postal',
      it: 'Codice postale',
      fr: 'Code postal',
    },
    address1_city: { en: 'City', de: 'Stadt', es: 'Ciudad', it: 'Città', fr: 'Ville' },
    address1_country: { en: 'Country', de: 'Land', es: 'País', it: 'Paese', fr: 'Pays' },
    address1_label: { en: 'Label', de: 'Label', es: 'Label', it: 'Label', fr: 'Label' },

    address2_addressee: {
      en: '2. Addressee',
      de: '2.Adressat',
      es: '2.Destinatario',
      it: '2.Destinatario',
      fr: '2.Destinataire',
    },
    address2_addressLine1: {
      en: '2. Address Line 1',
      de: '2. Adresszeile 1',
      es: '2. Dirección Línea 1',
      it: '2. Indirizzo Linea 1',
      fr: '2. Adresse Ligne 1',
    },
    address2_addressLine2: {
      en: '2. Address Line 2',
      de: '2. Adresszeile 2',
      es: '2. Dirección Línea 2',
      it: '2. Indirizzo Linea 2',
      fr: '2. Adresse Ligne 2',
    },
    address2_postCode: {
      en: '2. Postcode',
      de: '2. PLZ',
      es: '2. Código postal',
      it: '2. Codice postale',
      fr: '2. Code postal',
    },
    address2_city: {
      en: '2. City',
      de: '2. Stadt',
      es: '2. Ciudad',
      it: '2. Città',
      fr: '2. Ville',
    },
    address2_country: {
      en: '2. Country',
      de: '2. Land',
      es: '2. País',
      it: '2. Paese',
      fr: '2. Pays',
    },
    address2_label: {
      en: '2. Label',
      de: '2. Label',
      es: '2. Label',
      it: '2. Label',
      fr: '2. Label',
    },
    workUrl: {
      en: 'Homepage URL',
      de: 'Homepage URL',
      es: 'URL de la página web',
      it: 'URL della pagina web',
      fr: 'URL du site web',
    },
    preferredLang: {
      en: 'Language',
      de: 'Sprache',
      es: 'Idioma',
      it: 'Lingua',
      fr: 'Langue',
    },

    costCenter: {
      en: 'Cost Center',
      de: 'Kostenstelle',
      es: 'Centro de coste',
      it: 'Centro di costo',
      fr: 'Centre de coût',
    },
    internalNotes: {
      en: 'Internal Notes',
      de: 'Interne Notizen',
      es: 'Notas internas',
      it: 'Note interne',
      fr: 'Notes internes',
    },
    createdOn: {
      en: 'Created on',
      de: 'Erstellt am',
      es: 'Creado el',
      it: 'Creato il',
      fr: 'Créé le',
    },
  },
  footer: {
    imprint: {
      en: 'Imprint',
      de: 'Impressum',
      es: 'Imprenta',
      it: 'Stampa',
      fr: 'Mentions légales',
    },
    privacyPolicy: {
      en: 'Privacy',
      de: 'Datenschutz',
      es: 'Privacidad',
      it: 'Privacy',
      fr: 'Confidentialité',
    },
  },
} as const;

/**
 * Default Values
"header.saveContactButton","Kontakt speichern","Save contact"
"contactDetailsBox.saveContactButton","vcard","vcard"
"contactDetailsBox.boxLabel","Meine Kontaktdaten","My Contact Details"
"contactDetailsBox.mobilePhone","Mobil","Mobile"
"contactDetailsBox.homePhone","Festnetz","Home"
"contactDetailsBox.workPhone","Arbeit","Work"
"contactDetailsBox.hotlinePhone","Hotline","Hotline"
"contactDetailsBox.assistance","Assistenz","Assistance"
"contactDetailsBox.fax","Fax","Fax"
"linksBox.boxLabel","Meine Links","My Links"
"filesBox.boxLabel","Meine Dateien","My Files"
"leadGen.bottomCardStatic.title","Hinterlasse Deinen Kontakt","Leave me your contact"
"leadGen.bottomCardStatic.showMore","Mehr anzeigen","Show more"
"leadGen.bottomCardStatic.showLess","Weniger anzeigen","Show less"
"leadGen.bottomCardStatic.submitButton","Absenden","Submit"
"leadGen.bottomCardStatic.gdprConsent","Durch Absenden bestätige ich, dass ich mit der Verarbeitung meiner Daten im Kontakt-Management von Lemontaps, und gegebenfalls der Firma des*der Benutzer*in, <0>(Datenschutzerklärung)</0> zu den genannten Zwecken einverstanden bin. Ich kann meine Einwilligung jederzeit widerrufen.","By submitting I confirm that I consent to the processing of my contact details in the contact management of the Lemontaps user, as well as that of their company, if applicable <0>(privacy policy)</0>. I can revoke this consent at any time."
"leadGen.popup.title","Sende Deine Kontaktdaten und
erhalte meine per E-Mail:","Send me your contact and
receive mine by email:"
"leadGen.popup.showMore","Mehr anzeigen - optional","Show more - optional"
"leadGen.popup.showLess","Weniger anzeigen","Show less"
"leadGen.popup.submitButton","Jetzt vernetzen","Let's connect"
"leadGen.popup.gdprConsent","Durch Absenden bestätige ich, dass ich die <0>Datenschutzerklärung</0> zur Kenntnis genommen habe und mit der Verarbeitung meiner Daten im Kontakt-Management des Lemontaps Nutzers und gegebenfalls seiner Firma<1> (Datenschutzerklärung)</1> zu den genannten Zwecken einverstanden bin. Du kannst jederzeit Deine Einwilligung widerrufen.","By submitting I confirm that I have read the <0>privacy policy</0> and that I consent to the processing of my contact details in the contact management of the Lemontaps user, as well as that of their company, if applicable<1> (privacy policy)</1>. You can revoke this consent at any time."
"attributeLabels.firstName","Vorname","First Name"
"attributeLabels.lastName","Nachname","Last Name"
"attributeLabels.academicDegree","Akademischer Grad (z.B. Ing, B.Sc.)","Academic Degree (e.g. Ing, B.Sc.)"
"attributeLabels.namePrefix","Namenspräfix","Name Prefix"
"attributeLabels.birthday","Geburtstag","Birthday"
"attributeLabels.position","Position","Position"
"attributeLabels.role","Rolle","Role"
"attributeLabels.company","Unternehmen","Company"
"attributeLabels.division","Abteilung","Division"
"attributeLabels.email","E-Mail","E-Mail"
"attributeLabels.workEmail","E-Mail Arbeit","Work E-Mail"
"attributeLabels.workPhone","Telefon - Arbeit","Telephone - Work"
"attributeLabels.mobilePhone","Telefon - Mobil","Telephone - Mobile"
"attributeLabels.addressee","Adressat","Addressee"
"attributeLabels.addressLine1","Adresszeile 1","Address Line 1"
"attributeLabels.addressLine2","Adresszeile 2","Address Line 2"
"attributeLabels.postCode","PLZ","Postcode"
"attributeLabels.city","Stadt","City"
"attributeLabels.country","Land","Country"
"attributeLabels.notes","Notizen","Notes"
"footer.imprint","Impressumg","Imprint"
"footer.privacyPolicy","Datenschutz","Privacy"
 */
